import React from 'react';
import EmailAddressesDropDown from 'components/Settings/EmailAddressesList/EmailAddressesDropDown';
import CrmContactsSelect from 'components/Dashboard/Influence/CrmEmails/CrmContactsSelect/CrmContactsSelect';
import InfoTooltip from './SentPerformance/InfoTooltip';
import useGetInitialEmailAddress from './useGetInitialEmailAddress';
import MailMergeModal from 'components/Dashboard/Influence/CrmEmails/MailMergeSection/MailMergeModal';

const FromToFields = ({
  disabledCondition,
  emailAddresses,
  currentEmailDetails,
  handleFrom,
  disabledToCondition,
  initialToValue,
  autofocusField,
  isMobile,
  setActiveTab,
  setActiveRecipientsOption,
  refreshEmailData,
}) => {
  const { getInitialSenderEmailAddress } = useGetInitialEmailAddress();
  const initialRecipients = initialToValue() ?? [];
  const recipientsKey = initialRecipients.map((item) => item?.id ?? item?.value ?? '').join(',');

  return (
    <div className={`email-component-section ${!isMobile ? 'email-component-side-section' : ''}`}>
      <div className='email-component-from specific-bottom-margin-32'>
        <span className='labelText text-700'>From</span>
        <div
          style={{
            marginLeft: !disabledCondition && isMobile ? '16px' : undefined,
          }}
        >
          <EmailAddressesDropDown
            senderAddresses={emailAddresses}
            value={getInitialSenderEmailAddress(currentEmailDetails.senderEmailAddressId, emailAddresses)}
            handleChange={handleFrom}
            disabledCondition={disabledCondition}
            emailBody
            sideBar={!isMobile}
          />
        </div>
      </div>
      <div
        className={`email-component-from email-component-to-section ${
          !isMobile ? 'd-flex flex-column' : ''
        } specific-bottom-margin-8`}
      >
        <span className='labelText d-flex text-700'>
          To{' '}
          {!disabledToCondition && (
            <InfoTooltip
              text={'Each message will be sent<br/> separately. Recipients will<br/> not see each other.'}
              senderDropdown
            />
          )}
        </span>

        {initialRecipients && (
          <CrmContactsSelect
            key={recipientsKey}
            initialValues={initialRecipients}
            disabled={disabledToCondition}
            autoFocus={autofocusField() === 'to'}
            sideBar={!isMobile}
            sentEmail={currentEmailDetails?.status === 'Sent' || currentEmailDetails?.status === 'PartiallySent'}
            setActiveTab={setActiveTab}
            setActiveRecipientsOption={setActiveRecipientsOption}
            refreshEmailData={refreshEmailData}
          />
        )}
      </div>
      <MailMergeModal currentEmailDetails={currentEmailDetails} refreshEmailData={refreshEmailData} />
    </div>
  );
};
export default FromToFields;
